import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  BLOCK_UNBLOCK_SWITCH,
  GET_USER,
  GET_HISTORY,
  EDIT_COIN,
  ASSIGN_BADGE,
  ASSIGN_FRAME,
  ASSIGN_TAG,
  UPDATE_USERNAME,
  UPDATE_UNIQUE_ID,
  UPDATE_USER_COUNTRY,
  UPDATE_USD_BALANCE,
} from "./types";

import { apiInstanceFetch } from "../../util/api";

export const getUser =
  (start, limit, searchValue, sDate, eDate) => (dispatch) => {
    apiInstanceFetch
      .get(
        `user/getUsers?start=${start}&limit=${limit}&search=${searchValue}&startDate=${sDate}&endDate=${eDate}`
      )
      .then((res) => {
        if (res.status) {
          let male, female;
          if (res.maleFemale) {
            res.maleFemale.map((data) => {
              if (data._id === "female") female = data.gender;
              if (data._id === "male") male = data.gender;
            });
          }
          dispatch({
            type: GET_USER,
            payload: {
              user: res.user,
              activeUser: res.activeUser,
              total: res.total,
              male,
              female,
            },
          });
        } else {
          Toast("error", res.message);
        }
      })
      .catch((error) => Toast("error", error.message));
  };

export const handleBlockUnblockSwitch = (userId) => (dispatch) => {
  axios
    .patch(`user/blockUnblock/${userId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: BLOCK_UNBLOCK_SWITCH, payload: res.data.user });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const userHistory = (data) => (dispatch) => {
  axios
    .post(`history`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_HISTORY, payload: res.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const editCoin = (data) => (dispatch) => {
  axios
    .post(`/user/addLessCoin`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: EDIT_COIN,
          payload: { data: res.data.user, id: data.userId },
        });
        Toast("success", "Update Successful!!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const assignBadge = (payload) => (dispatch) => {
  return axios
    .post("user/assignBadge", { action: "add", ...payload })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ASSIGN_BADGE, payload: res.data.user });
        Toast("success", "Badge updated!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((err) => Toast("error", err.message));
};

export const assignFrame =
  ({ uniqueId, frameId, action = "add" }) =>
  (dispatch) => {
    return axios
      .post(`svga/frame/${frameId}/assign`, { uniqueId, action })
      .then((res) => {
        if (res.data.status) {
          Toast("success", "Frame updated!");
          dispatch({ type: ASSIGN_FRAME, payload: res.data.user });
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((err) => Toast("error", err.message));
  };

/* -------------------------
     TAG ASSIGN / REMOVE
-------------------------- */
export const assignTag =
  ({ userId, tagId, action = "add" }) =>
  (dispatch) => {
    return axios
      .post("user/assignTag", { userId, tagId, action })
      .then((res) => {
        if (res.data.status) {
          dispatch({ type: ASSIGN_TAG, payload: res.data.user });
          Toast("success", "Tag updated!");
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((err) => Toast("error", err.message));
  };

// Update Username
export const updateUsername = (data) => (dispatch) => {
  axios
    .patch(`/user/updateUsername`, data)
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: UPDATE_USERNAME,
          payload: { id: data.userId, username: data.newUsername },
        });
        Toast("success", "Username updated successfully!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const changeUserCountry = (data) => (dispatch) => {
  axios
    .post(`user/updatecountry`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: UPDATE_USER_COUNTRY,
          payload: res.data.user,
        });
        Toast("success", "Country updated successfully!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
// Update USD Balance (admin)
export const editUsdBalance = (data) => (dispatch) => {
  axios
    .patch(`/user/updateUsdBalance`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: UPDATE_USD_BALANCE,
          payload: { id: data.userId, usdBalance: data.usdBalance },
        });
        Toast("success", "USD Balance updated successfully!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

// Update UniqueId
export const updateUniqueId = (data) => (dispatch) => {
  axios
    .patch(`/user/updateUniqueId`, data)
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: UPDATE_UNIQUE_ID,
          payload: { id: data.userId, uniqueId: data.newUniqueId },
        });
        Toast("success", "Unique ID updated successfully!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
